import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { useInputGroupContext } from '../InputGroup/index.js';
import { StyledBaseInput } from '../Input/index.js';

/**
 * The Textarea component allows you to easily create multi-line text inputs.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/textarea#usage)
 * - [Props](https://blockparty.endpoint.com/components/textarea#props)
 * <br />
 *
 */
const Textarea = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    dataTestId = 'textarea',
    isDisabled,
    isInvalid,
    isRequired,
    isReadOnly,
    ...rest
  } = _ref;
  const formControl = useInputGroupContext();
  const _isDisabled = isDisabled || formControl.isDisabled;
  const _isInvalid = isInvalid || formControl.isInvalid;
  const _isRequired = isRequired || formControl.isRequired;
  const _isReadOnly = isReadOnly || formControl.isReadOnly;
  return /*#__PURE__*/React__default.createElement(StyledBaseInput, _extends({
    ref: forwardedRef,
    "aria-disabled": _isDisabled,
    "aria-invalid": _isInvalid,
    "aria-readonly": _isReadOnly,
    "aria-required": _isRequired,
    as: "textarea",
    border: "1px solid",
    borderColor: "inputDefault",
    borderRadius: "radiusDefault",
    "data-test-id": dataTestId,
    disabled: _isDisabled,
    fontFamily: "normal",
    fontSize: {
      base: 'fontSize30',
      md: 'fontSize20'
    },
    id: formControl.groupId,
    isInvalid: _isInvalid,
    lineHeight: {
      base: 'lineHeight30',
      md: 'lineHeight20'
    },
    minHeight: "80px",
    padding: "9px 12px",
    required: _isRequired // Fixes conflict with InputElemGroup Icons
    ,
    resize: "vertical",
    width: "100%"
  }, rest));
});

export { Textarea };
